export const ISSUE_STATUSES = [
  { key: "SUBMITTED", name: "SUBMITTED", color: "blue" },
  { key: "ESCALATED_TO_COURIER", name: "ESCALATED TO COURIER", color: "lime" },
  { key: "RESOLVED", name: "RESOLVED", color: "green" },
  { key: "CANCELLED", name: "CANCELLED", color: "gray" },
  { key: "PENDING_SENDER_UPDATE", name: "PENDING SENDER UPDATE", color: "yellow" },
];

export const ISSUE_CATEGORIES = {
  DAMAGED_PARCEL: {
    key: "DAMAGED_PARCEL",
    label: "Damaged Parcel",
    color: "blue",
  },
  PARCEL_DELAY: {
    key: "PARCEL_DELAY",
    label: "Parcel Delay / Redelivery",
    color: "lime",
  },
  WEIGHT_DISPUTE_APPEAL: {
    key: "WEIGHT_DISPUTE_APPEAL",
    label: "Weight Dispute Appeal",
    color: "green",
  },
  CLAIM: {
    key: "CLAIM",
    label: "Claim",
    color: "orange",
  },
  DELIVERED_NOT_RECEIVED: {
    key: "DELIVERED_NOT_RECEIVED",
    label: "Delivered not Received",
    color: "yellow"
  },
  AMEND_DETAILS: {
    key: "AMEND_DETAILS",
    label: "Amend Details",
    color: "purple"
  },
  RETURN_REQUEST: {
    key: "RETURN_REQUEST",
    label: "Return Request",
    color: "red"
  }
};
